module.exports = __webpack_public_path__ + "img/reference05.c57d37a9.jpg";